module.exports = __webpack_public_path__ + "static/img/img_yishu.ff6cec0.ff6cec07.jpg";